import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-135" data-mp="2z5bcytzifl9f">
      <div className="mx-auto max-w-3xl" data-id="element-136" data-mp="3msji9bwxuubg">
        <SectionHeading title="Frequently Asked Questions" data-id="element-137" data-mp="3muw9ygsi0j1p" />

        <div className="mt-10 divide-y divide-navy/10 rounded-2xl border border-navy/10" data-id="element-138" data-mp="3rqut9pyyzav9">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-139" data-mp="3i1b8ufvlz8ya" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-140" data-mp="3i0ibg5ijhvst">
                  <span className="text-[16px] font-bold leading-snug text-navy" data-id="element-141" data-mp="20px66n9cjzeb">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-142" data-mp="1vsexmxz8rm6u" />
                </button>
                <AnimatePresence initial={false} data-id="element-143" data-mp="25nqeblu7n3h8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-144" data-mp="2jfdazms2ee0j">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-navy/75" data-id="element-145" data-mp="z0l45p7tkvk6">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA label="Get Complete Access" data-id="element-146" data-mp="1js8ifwtu6vqd" />
      </div>
    </section>;
}